import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {forwardRef, useContext, useEffect, useState} from "react";
import {displayPhone, formatDateMask, handleDefaultValues, toDate, isValidDob, DOB_INPUT_MIN, DOB_INPUT_MAX} from "../common/Utils";
import {set, useForm} from 'react-hook-form';
import {getFamilyMemberTypes} from "../common/api/WebApi";
import MDInput from "../../components/MDInput";
import {NativeSelect} from "@mui/material";
import MDButton from "../../components/MDButton";

export default function ManageFamilyMemberModal({
                                                  familyMember,
                                                  show,
                                                  saving,
                                                  handleSaveFamilyMember,
                                                  handleCloseFamilyMember
                                                }) {

  const [context, setContext] = useContext(AppContext);
  const [isChild, setIsChild] = useState(false);

  const [member, setMember] = useState({...familyMember});
  const [emergencyContact, setEmergencyContact] = useState();
  const [familyMemberTypes, setFamilyMemberTypes] = useState([]);
  const [typesReady, setTypesReady] = useState(false);

  const [dobReady, setDobReady] = useState(false);
  useEffect(() => {
    if (familyMember && familyMember?.familyMemberType?.id === 1) {
      setIsChild(true);
    }
  }, [familyMember]);

  const [isNew, setIsNew] = useState(!!!member?.guid);
  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(() => {
    getFamilyMemberTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setFamilyMemberTypes(result);
        setTypesReady(true);
      }
    });
  }, [show]);

  useEffect(()=> {
    if (typesReady && isNew) {
      setValue('familyMemberType.id', 1);
      setIsChild(true);
    }
  }, [isNew, typesReady])

  const {register, handleSubmit, setValue, control, formState: {errors}} = useForm({
    values: handleDefaultValues(member)
  });


  const handleSaveFamilyMemberFn = (data) => {
    let _d = {...data};
    handleSaveFamilyMember(_d);
    setMember(null);
  };

  const toggleEmergencyContact = (e) => {
    setEmergencyContact(e.target.checked);
  };

  return (
    <Modal onHide={handleCloseFamilyMember} size={'lg'} fullscreen={true} dialogClassName={'psb-page-overlay psb-overlay-medium'} show={show}>
      <form onSubmit={handleSubmit(handleSaveFamilyMemberFn)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Family Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="firstName">First Name</label>
                      <MDInput
                        variant="outlined" type="text" required
                        {...register('firstName')}
                        className="form-control" id="firstName"
                        placeholder="Enter First name"/>
                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="lastName">Last Name</label>
                      <MDInput
                        variant="outlined" type="text" required
                        {...register('lastName')}
                        className="form-control" id="lastName"
                        placeholder="Enter Last name"/>
                    </div>
                  </Col>
                </Row>


                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="state">Family Member Type</label>
                      {typesReady && <NativeSelect required
                                                   id={'familyMemberType'}
                                                   variant="outlined"
                                                   name={'familyMemberType'} className={'form-control'}
                                                   {...register('familyMemberType.id', {
                                                     required: true,
                                                     min: 1,
                                                     onChange: ((e) => {
                                                       setIsChild(parseInt(e.target.value, 10) === 1)
                                                     })
                                                   })} >
                        {
                          familyMemberTypes.map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.name}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={8}>

                    {isChild &&
                      <div className="form-group">
                        <label htmlFor="dob">Birth Date</label>
                        <div>
                          <input
                            required={isChild}
                            {...register('dob', {
                              required: isChild,
                              validate: (value) => !isChild || isValidDob(value) || 'Please enter a valid birth date'
                            })}
                            className={`form-control${errors.dob ? ' is-invalid' : ''}`}
                            type="date"
                            min={DOB_INPUT_MIN}
                            max={DOB_INPUT_MAX}
                          />
                        </div>
                        {errors.dob && <div className="invalid-feedback d-block">{errors.dob.message}</div>}
                      </div>
                    } &nbsp;

                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={6}>

                    {!isChild &&
                      <label htmlFor="emergencyContact" className={'mt-4'}>
                        <input type="checkbox"
                               {...register('emergencyContact',
                                 {
                                   onChange: (e) => {
                                     toggleEmergencyContact(e);
                                   }
                                 })}
                               id="emergencyContact"/>
                        &nbsp;Emergency Contact
                      </label>
                    } &nbsp;

                  </Col>
                </Row>
                {emergencyContact &&
                  <Row className={'my-2'}>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <label htmlFor="phoneNumber">Emergency Phone</label>
                        <MDInput
                          variant="outlined" type="text"
                          {...register('phoneNumber', {
                            onChange: (e) => {
                              e.target.value = displayPhone(e.target.value);
                            }
                          })}
                          className="form-control" id="phoneNumber"
                          placeholder="Enter Emergency Phone"/>
                      </div>
                    </Col>
                  </Row>
                }

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}